export default __webpack_public_path__ + "static/media/stats.7e9146ca.png";